<app-page-header [title]="title.getTitle()"></app-page-header>
<section class="page-area">
  <div class="padded-content top-bottom-padding">
    <app-content-header title="The requested page does not exist"></app-content-header>
    <a class="btn btn-primary" href="/">Return to the dashboard</a>
  </div>
</section>
